import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import CircularProgress from '@mui/material/CircularProgress'
import AttachFile from '@mui/icons-material/AttachFile'
import ArrowBack from '@mui/icons-material/ArrowBack'

const RestTunel = require('../../libs/rest_tunnel')
const session = require('../../config/session')

const COLOR_ESTADO = {
  'Nueva': 'info', 'Recibida': 'info', 'En revisión': 'warning', 'En proceso': 'primary',
  'Pendiente de información': 'warning', 'Solucionada': 'success', 'Cerrada': 'default'
}

class SoporteDetallePage extends Component {
  constructor(props) {
    super(props)
    const params = new URLSearchParams(props.location ? props.location.search : '')
    this.state = {
      id: parseInt(params.get('id'), 10),
      caso: null, conversacion: [], cargando: true,
      contenido: '', archivo: null, enviando: false,
      snack: { open: false, severity: 'success', msg: '' }
    }
  }

  componentDidMount() { this.cargar() }

  avisar = (severity, msg) => this.setState({ snack: { open: true, severity, msg } })

  cargar = () => {
    if (isNaN(this.state.id)) { this.setState({ cargando: false }); return this.avisar('error', 'Solicitud inválida') }
    this.setState({ cargando: true })
    RestTunel.makePetition({
      method: 'POST', headers: 'JSON', body: { solicitud_id: this.state.id },
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/detalle'
    }, (err, data) => {
      if (err) { this.setState({ cargando: false }); return this.avisar('error', (data && data.message) || 'No se pudo cargar el caso') }
      this.setState({ caso: data.caso, conversacion: data.conversacion || [], cargando: false })
    })
  }

  enviarMensaje = () => {
    const s = this.state
    if ((!s.contenido || !s.contenido.trim()) && !s.archivo) return this.avisar('warning', 'Escribe un mensaje')
    const fd = new FormData()
    fd.append('solicitud_id', s.id)
    fd.append('contenido', s.contenido)
    if (s.archivo) fd.append('adjunto', s.archivo)
    this.setState({ enviando: true })
    RestTunel.makePetition({
      method: 'POST', body: fd,
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/mensaje'
    }, (err, data) => {
      this.setState({ enviando: false })
      if (err) return this.avisar('error', (data && data.message) || 'No se pudo enviar')
      this.setState({ contenido: '', archivo: null })
      this.cargar()
    })
  }

  accion = (ruta, body, okMsg) => {
    RestTunel.makePetition({
      method: 'POST', headers: 'JSON', body: Object.assign({ solicitud_id: this.state.id }, body || {}),
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/' + ruta
    }, (err, data) => {
      if (err) return this.avisar('error', (data && data.message) || 'No se pudo completar')
      this.avisar('success', okMsg)
      this.cargar()
    })
  }

  confirmar = () => this.accion('confirmar', {}, 'Solución confirmada')
  reabrir = () => {
    const motivo = window.prompt('Motivo de la reapertura (opcional):', '')
    if (motivo === null) return
    this.accion('reabrir', { motivo }, 'Caso reabierto')
  }

  descargarAdjunto = (m) => {
    fetch(process.env.REACT_APP_URL_BACKEND + '/soporte/adjunto', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-access-token': '' + session.getToken(), 'dashboard-version': '' + process.env.REACT_APP_VERSION },
      body: JSON.stringify({ mensaje_id: m.id })
    }).then(r => {
      const ct = r.headers.get('content-type') || ''
      if (ct.indexOf('application/json') !== -1) { return r.json().then(() => { throw new Error('json') }) }
      return r.blob()
    }).then(blob => {
      const url = URL.createObjectURL(blob)
      window.open(url, '_blank')
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    }).catch(() => this.avisar('error', 'No se pudo abrir el adjunto'))
  }

  renderMensaje = (m) => {
    if (m.tipo === 'evento') {
      return (
        <Box key={m.id} sx={{ textAlign: 'center', my: 1 }}>
          <Typography variant="caption" color="text.secondary">— {m.contenido} · {m.fecha_creacion} —</Typography>
        </Box>
      )
    }
    const esCliente = m.origen === 'cliente'
    return (
      <Box key={m.id} sx={{ display: 'flex', justifyContent: esCliente ? 'flex-end' : 'flex-start', my: 1 }}>
        <Paper sx={{ p: 1.5, maxWidth: '75%', bgcolor: esCliente ? '#E3F2FD' : '#F1F1F1' }}>
          <Typography variant="caption" color="text.secondary">
            {esCliente ? 'Tú' : (m.autor || 'Soporte')} · {m.fecha_creacion}
          </Typography>
          {m.contenido && <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 0.5 }}>{m.contenido}</Typography>}
          {m.tiene_adjunto === 1 &&
            <Button size="small" startIcon={<AttachFile />} onClick={() => this.descargarAdjunto(m)} sx={{ mt: 0.5, textTransform: 'none' }}>
              {m.adjunto_nombre || 'Ver adjunto'}
            </Button>}
        </Paper>
      </Box>
    )
  }

  render() {
    const s = this.state
    if (s.cargando) return <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>
    const c = s.caso
    if (!c) return <Box sx={{ p: 3 }}><Typography>No se encontró el caso.</Typography></Box>

    const puedeResponder = session.checkPermiso('acceder_dashboard')
    const cerrada = c.estado === 'Cerrada'

    return (
      <Box sx={{ p: 2 }}>
        <Button component={Link} to="/dashboard/soporte" startIcon={<ArrowBack />} sx={{ mb: 1 }}>Volver</Button>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <Typography variant="h6">{c.sup}{c.bandera_reabierta ? ' (reabierta)' : ''}</Typography>
            <Chip label={c.estado} color={COLOR_ESTADO[c.estado] || 'default'} />
          </Box>
          <Grid container spacing={1} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}><Typography variant="body2"><b>Tipo:</b> {c.tipo === 'maquina' ? 'Máquina' : 'Plataforma'}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><b>{c.tipo === 'maquina' ? 'Cajero' : 'Módulo'}:</b> {c.tipo === 'maquina' ? (c.cajero_codigo || '-') : (c.modulo || '-')}</Typography></Grid>
            {c.tipo === 'maquina' && <Grid item xs={12} sm={6}><Typography variant="body2"><b>Categoría:</b> {c.categoria || '-'}</Typography></Grid>}
            <Grid item xs={12} sm={6}><Typography variant="body2"><b>Severidad:</b> Nivel {c.severidad}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><b>Creada:</b> {c.fecha_creacion}</Typography></Grid>
            {c.fecha_solucion && <Grid item xs={12} sm={6}><Typography variant="body2"><b>Solucionada:</b> {c.fecha_solucion}</Typography></Grid>}
            <Grid item xs={12}><Divider sx={{ my: 1 }} /><Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}><b>Descripción:</b> {c.descripcion}</Typography></Grid>
            {c.info_adicional && <Grid item xs={12}><Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}><b>Información adicional:</b> {c.info_adicional}</Typography></Grid>}
          </Grid>

          <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
            {c.estado === 'Solucionada' && <Button variant="contained" color="success" onClick={this.confirmar}>Confirmar solución</Button>}
            {(c.estado === 'Solucionada' || c.estado === 'Cerrada') && puedeResponder &&
              <Button variant="outlined" onClick={this.reabrir}>Reabrir</Button>}
          </Box>
        </Paper>

        <Paper sx={{ p: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>Conversación</Typography>
          <Box sx={{ maxHeight: 420, overflowY: 'auto', px: 1 }}>
            {s.conversacion.length === 0 && <Typography variant="body2" color="text.secondary">Sin mensajes aún.</Typography>}
            {s.conversacion.map(this.renderMensaje)}
          </Box>

          {!cerrada && puedeResponder &&
            <Box sx={{ mt: 2 }}>
              <Divider sx={{ mb: 2 }} />
              <TextField fullWidth multiline minRows={2} placeholder="Escribe una respuesta…"
                value={s.contenido} onChange={(e) => this.setState({ contenido: e.target.value })} inputProps={{ maxLength: 5000 }} />
              <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button variant="outlined" component="label" startIcon={<AttachFile />} sx={{ textTransform: 'none' }}>
                  {s.archivo ? s.archivo.name : 'Adjuntar'}
                  <input type="file" hidden accept="image/*,application/pdf" onChange={(e) => this.setState({ archivo: e.target.files[0] || null })} />
                </Button>
                <Button variant="contained" disabled={s.enviando} onClick={this.enviarMensaje}>{s.enviando ? 'Enviando…' : 'Enviar'}</Button>
              </Box>
            </Box>}
          {cerrada && <Typography variant="caption" color="text.secondary">El caso está cerrado (solo lectura).</Typography>}
        </Paper>

        <Snackbar open={s.snack.open} autoHideDuration={4000} onClose={() => this.setState({ snack: { ...s.snack, open: false } })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={s.snack.severity} onClose={() => this.setState({ snack: { ...s.snack, open: false } })}>{s.snack.msg}</Alert>
        </Snackbar>
      </Box>
    )
  }
}

export default SoporteDetallePage
